<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Shipper Management <small class="text-muted">stores</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="courier_id" class="col-sm-2 col-form-label">{{ $t('marketplace.marketplace_name') }}</label>
                        <div class="col-sm-4">
                          <select class="form-control" v-model.trim="marketpalceStore.marketplace_id">
                            <option v-for="(marketplace, index) in marketplaces" :value="marketplace.id" :key="index">{{ marketplace.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="store_account" class="col-sm-2 col-form-label form__label">{{ $t('marketplace.store.store_account') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.marketpalceStore.store_account.$error }">
                          <input v-model.trim="marketpalceStore.store_account" @input="$v.marketpalceStore.store_account.$touch()" type="text" name="store_account" class="form-control form__label">
                        </div>
                        <label for="store_user_id" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_user_id') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.marketpalceStore.store_user_id.$error }">
                          <input v-model.trim="marketpalceStore.store_user_id" @input="$v.marketpalceStore.store_user_id.$touch()" type="text" name="store_user_id" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="store_token" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_token') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.marketpalceStore.store_token.$error }">
                          <input v-model.trim="marketpalceStore.store_token" @input="$v.marketpalceStore.store_token.$touch()" type="text" name="store_token" class="form-control" />
                        </div>
                        <label for="store_email" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_email') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.marketpalceStore.store_email.$error }">
                          <input v-model.trim="marketpalceStore.store_email" @input="$v.marketpalceStore.store_email.$touch()" type="text" name="store_email" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="store_currency" class="col-sm-2 col-form-label">{{ $t('marketplace.store.store_currency') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.marketpalceStore.store_currency.$error }">
                          <input v-model.trim="marketpalceStore.store_currency" @input="$v.marketpalceStore.store_currency.$touch()" type="text" name="store_currency" class="form-control" />
                        </div>
                        <label for="service_url" class="col-sm-2 col-form-label">{{ $t('marketplace.store.service_url') }}</label>
                        <div class="col-sm-3">
                          <input v-model.trim="marketpalceStore.service_url" type="text" name="service_url" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="time_schedule" class="col-sm-2 col-form-label">{{ $t('marketplace.store.time_schedule') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.marketpalceStore.time_schedule.$error }">
                          <select v-model.trim="marketpalceStore.time_schedule" @input="$v.marketpalceStore.time_schedule.$touch()"  name="time_schedule" class="form-control">
                            <option value="all">All</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="debug" class="col-sm-2 col-form-label">{{ $t('marketplace.store.debug') }}</label>
                        <div class="col-sm-3">
                          <select v-model.trim="marketpalceStore.debug" name="debug" class="form-control">
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="status" class="col-sm-2 col-form-label">{{ $t('marketplace.store.status') }}</label>
                        <div class="col-sm-8">
                          <CSwitch class="mx-1"  :checked.sync="marketpalceStore.status" color="primary" variant="outline" shape="pill"/>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'StoreCreate',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/marketplace/platform').then(response => {
      this.marketplaces = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      marketplaces: [],
      marketpalceStore: {
        marketplace_id: '',
        store_account: '',
        store_user_id: '',
        store_token: '',
        store_email: '',
        store_currency: '',
        service_url: '',
        time_schedule: '',
        debug: '',
        remark: '',
        status: true
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      // create store
      this.showLoadingPanel = true
      this.axios.post('/marketplace/store', this.marketpalceStore).then(() => {
        this.showLoadingPanel = false
        this.$router.push('/marketplace/store')
      }).catch(error => {
        this.showLoadingPanel = false
        this.showAlert('danger', error.data.message)
      })
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  },
  validations: {
    marketpalceStore: {
      store_account: {
        required,
        minLength: minLength(10)
      },
      store_user_id: {
        required
      },
      store_token: {
        required
      },
      store_email: {
        required
      },
      store_currency: {
        required
      },
      time_schedule: {
        required
      },
      debug: {
        required
      }
    }
  }
}
</script>
